import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show notification after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Auto hide after 10 seconds of being visible
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-279">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-280">
          <div className="bg-white rounded-xl shadow-2xl border border-sand p-4 pr-10 relative overflow-hidden" data-id="element-281">
            {/* Accent line */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-forest" data-id="element-282"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-muted hover:text-forest-dark p-1" aria-label="Cerrar notificación" data-id="element-283">
              <X className="w-4 h-4" data-id="element-284" />
            </button>

            <div className="flex items-start gap-3" data-id="element-285">
              <div className="mt-0.5 shrink-0" data-id="element-286">
                <CheckCircle2 className="w-5 h-5 text-forest" data-id="element-287" />
              </div>
              <div data-id="element-288">
                <p className="text-xs font-bold text-forest uppercase tracking-wider mb-1" data-id="element-289">
                  Compra verificada
                </p>
                <p className="text-sm text-forest-dark leading-tight" data-id="element-290">
                  <strong data-id="element-291">Docente de Minería</strong> de San Juan compró
                  <br data-id="element-292" />
                  <span className="text-gold-dark font-medium" data-id="element-293">
                    MegaPack Minería + Upsell Premium ⛏️
                  </span>
                </p>
                <p className="text-xs text-muted mt-2" data-id="element-294">Hace 2 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}